// Speicherstatus am Berechnungs-Chip im Header. Eigene Datei, damit
// AppHeader.jsx nur Komponenten exportiert (react-refresh).
export function saveStatusPill({ isPro, currentProject, currentCalculation, saving, saveError, isDirty, preview }) {
  if (!isPro || !currentProject) return null;
  if (preview) return { label: 'Vorschau', cls: 'text-brand', title: 'Alter Stand, nur ansehen' };
  if (saving) return { label: 'speichert …', cls: 'text-ink-3' };
  if (saveError) return { label: 'Nicht gespeichert', cls: 'text-err', title: `Nicht gespeichert: ${saveError}` };
  if (isDirty) return { label: '●', cls: 'text-warn', title: 'Ungespeicherte Änderungen' };
  if (currentCalculation) return { label: '✓', cls: 'text-ok', title: 'Gespeichert' };
  return null;
}
